'use client';
import { Dialog, DialogContent, DialogFooter } from '@repo/ui';
import Link from 'next/link';
import { ReactNode, useEffect, useState } from 'react';

export const CareInductionModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  const day3Close = () => {
    const whenWillBeExpired = Math.floor(new Date().getTime()) + 1000 * 60 * 60 * 24 * 3;
    if (typeof window !== 'undefined') {
      localStorage.setItem('hasVisitedBefore', `${whenWillBeExpired}`);
    }
    setIsOpen(false);
  };

  useEffect(() => {
    const HAS_VISITED_BEFORE = localStorage.getItem('hasVisitedBefore');
    const currentUNIX = Math.floor(new Date().getTime());

    setIsOpen(!HAS_VISITED_BEFORE || parseInt(HAS_VISITED_BEFORE, 10) < currentUNIX);
  }, []);

  useEffect(() => {
    const html = document.documentElement;
    if (isOpen) html.classList.add('no-scroll');
    else html.classList.remove('no-scroll');

    return () => {
      html.classList.remove('no-scroll');
    };
  }, [isOpen]);

  return (
    <Dialog onOpenChange={setIsOpen} open={isOpen}>
      <DialogContent className={'bg-neutral-background-inverse-main border-opacity-30 border-white border'} disableOutsideClick>
        <Link href={'https://ac.bznav.com/4wekmz'} className={'flex'} target={'_blank'} rel={'noopener noreferrer'}>
          <img src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/brand/home/modal/img_bznav-care-popup.png`} className={'w-full'} alt={'care 광고'} />
        </Link>
        <DialogFooter className={'flex items-center !pt-0'}>
          <ModalButton onClick={day3Close}>3일간 닫기</ModalButton>
          <div className={'divider !bg-gray-alpha-inverse-300 !h-4.5'}></div>
          <ModalButton onClick={() => setIsOpen(false)}>닫기</ModalButton>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

const ModalButton = ({ children, onClick }: { children: ReactNode; onClick: () => void }) => {
  return (
    <button className={'w-full bg-transparent py-5 body-small-medium text-white hover:text-gray-200'} onClick={onClick}>
      {children}
    </button>
  );
};
